<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                        
                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-7 col-lg-7 col-xs-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-lg-12">
                                                <p class="page-text">
                                                    Faça um novo <b>pré-agendamento</b> de abastecimento abaixo. Escolha o melhor <b>dia</b> e <b>horário</b> para você. Nossa equipe vai analisar, e retornará para <b>confirmar</b> ou <b>reagendar</b>.
                                                </p>
                                            </div>
                                        
                                            <div class="col-xl-8 col-xs-7 col-md-7">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual dia você deseja?</h5>
                                                </div>
                                                <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.data" required="">
                                            </div>

                                            <div class="col-xl-4 col-xs-5 col-md-5">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual horário?</h5>
                                                </div>
                                                <input type="time" class="with-border" data-placeholder="__ : __" v-model="form.horaInicio" required="">
                                            </div>

                                            <div class="col-xl-8 col-xs-12">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual o combustível?</h5>
                                                </div>

                                                <button class="button margin-bottom-15 margin-right-5" v-for="item in catalogo.itens" type="button" v-if="item.cor" style="width: 48%" :style="{'background-color': item.cor}" v-on:click="form.catalogoCod = item.cod;">
                                                    <i v-show="form.catalogoCod == item.cod" class="material-icons">check_circle</i>
                                                    {{item.nome.toUpperCase()}}
                                                </button>


<!--                                                 <button class="button margin-bottom-15" type="button" style="background: #11110f; width: 48%" v-on:click="form.catalogoCod = '5a9c3ee14eed0097353614fdecfc585d';">
                                                    <i v-show="form.catalogoCod == '5a9c3ee14eed0097353614fdecfc585d'" class="material-icons">check_circle</i>
                                                    JET-A1
                                                </button>

                                                <button class="button margin-bottom-15" type="button" style="background: #d21f1a; width: 48%" v-on:click="form.catalogoCod = '04ff777c356392bd98d24aa2ccd7fb72';">
                                                    <i v-show="form.catalogoCod == '04ff777c356392bd98d24aa2ccd7fb72'" class="material-icons">check_circle</i>
                                                    AVGAS
                                                </button>    -->                                             
<!--                                                 <select class="with-border" v-model="form.catalogoCod">
                                                    <option value="" disabled selected hidden>Selecione aqui..</option>
                                                    <option value="123">Avgas</option>
                                                    <option value="321">JET-A1</option>
                                                </select>  -->                                                                                                  
                                            </div>                                                    
                                            
                                            <div class="col-xl-4 col-xs-4 col-md-4">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Quantidade</h5>
                                                </div>
                                                <input type="number" class="with-border" placeholder="Litros" v-model="form.quantidade">
                                            </div>  

                                            <div class="col-xl-8 col-xs-8 col-md-7">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual o prefixo da aeronave?</h5>
                                                </div>
                                                <input type="text" class="with-border" style="text-transform: uppercase;" placeholder="_______" v-model="form.auxiliar1">
                                            </div>

                                            <div class="col-xl-12 col-xs-12">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual filial você deseja?</h5>
                                                </div>
                                            </div>

                                            <div class="col-xl-8 col-xs-12 col-md-8">
                                                <select class="with-border" v-model="form.empresaCod">
                                                    <option value="" disabled selected hidden>Selecione aqui..</option>
                                                    <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                </select>                                                   
                                            </div>                                                    

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-30 margin-top-15">
                                                <button type="submit" class="button green big block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="material-icons">check_circle</i>
                                                    Enviar pré-agendamento
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>

                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'PreAgendar',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        return {
            "loading": {
                "submit":           false
            },
            "empresas": {
                "itens":            []
            },
            "catalogo": {
                "itens":            []
            },                        
            "form": {
                "_cod":             "",
                "_token":           "",
                "data":             "",
                "horaInicio":       "",
                "quantidade":       "",
                "pontos":           0,
                "catalogoCod":      "",
                "empresaCod":       "",
                "auxiliar1":        ""
            }            
        }
    },
    watch: {
        "form.auxiliar1": function(val) {
            var self = this;
            console.log("change >> form.auxiliar1", val);
            if (val) {
                self.form.auxiliar1 = val.toUpperCase();
            }
        }
    },    
    methods: {
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            // if (self.form.cod) {
            //     a = "put";
            // }

            console.log("acao", a);

            axios[a]("api/agendamento.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },  
        getCatalogo: function() {
            var self        = this;
            console.log("getCatalogo()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("getCatalogo() response", response);
                    self.catalogo       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCatalogo() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                
    },    
    created: function() {
        var self = this;
        console.log("created", self);

        // if (self.$route.name == "EditarUsuariosGeral" || self.$route.name == "EditarUsuariosContratante") {
        //     if (!self.$route.query.c) {
        //         self.$root.back();
        //         return false;
        //     }
        //     self.form.cod = self.$route.query.c;
        //     self.get();
        // } else {
        //     loading.hide();
        // }

        Promise.all([
            self.getEmpresas(), 
            self.getCatalogo()
        ]).then(function() {
            loading.hide();
        }).catch(function(error) {
            loading.hide();
        }); 
        
    },    
    mounted: function() {
        // loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PreAgendar.vue